import Vue from 'vue';
import overview from '../../mixins/overview.js';
import transition_staggered_fade from '@/mixins/transition-staggered-fade-mixin.js';

Vue.component('overview-block', {
    mixins: [overview, transition_staggered_fade]
});
